export const documentsRoutes = [
    {
        path: "/document-personal",
        name: "DocumentPersonal",
        component: () => import(/* webpackChunkName: "D_Prs" */ "@/pages/DocumentPersonal"),
    },
    {
        path: "/document-confidentiality",
        name: "DocumentConfidentiality",
        component: () =>
            import(/* webpackChunkName: "D_Cnf" */ "@/pages/DocumentConfidentiality"),
    },
];
